export type Falsey = false | 0 | '' | null | undefined;
export type GeneralID = number | string;

export type Files = FileList | File[];
export type BooleanFlag = 0 | 1;

/** 颜色保存格式, 如: "0,0,0,1" */
export type ColorString = `${number},${number},${number},${number}` | '';

export type TabMain =
  | 'basic'
  | 'view'
  | 'hotspot'
  | 'music'
  | 'mask'
  | 'sandTable'
  | 'effect'
  | 'anchor'
  | 'rotate'
  | 'subtitle'
  | 'tagLine'
  | 'compass'
  | 'component'
  | 'compare';

export interface Channel {
  id: number;
  name: string;
}

export enum MediaType {
  system = 0,
  lib = 1,
}

export enum LinkTarget {
  modal = 0, // 弹窗
  blank = 1, // 新窗口
  window = 2, // 本窗口
}

/** 0白色边框, 1半透明蒙层, 默认1, v5.8.1 新增 */
export type OpenStyle = 0 | 1;

export type ModalSizeType = 0 | 1; // 0: 系统模式, 1: 自定义模式
interface ModalSizeItem {
  width: string; // 宽，可以是百分比也可以是绝对值
  height: string; // 高，可以是百分比也可以是绝对值
}
export interface ModalSize {
  mobile: ModalSizeItem;
  pc: ModalSizeItem;
}

export enum SelectStatus {
  none = 0,
  all = 1,
  part = 2,
}

export enum ImageType {
  image = 0,
  thumb = 1,
  media = 2,
  sysMedia = 3,
  watermark = 4,
}

export enum QiniuTokenType {
  media = 'media',
  thumb = 'thumb',
}

export interface MapLocation {
  zoom?: number;
  lat?: number;
  lng?: number;
}

export enum SceneType {
  panoVideo = 0,
  pano = 1,
  matrix = 2,
  image = 3,
  video = 4,
  tour = 5,
}

export enum DndType {
  scene = 'scene',
  category = 'category',
  subCategory = 'subCategory',
}

export interface DragItem {
  id: GeneralID;
  index: number;
}

export enum BucketType {
  public = 0,
  thumb = 1,
  private = 2,
  media = 3,
}

export interface LookToView {
  fov: number;
  hlookat: number;
  vlookat: number;
}
